// extracted by mini-css-extract-plugin
module.exports = {"userReportsList":"mUGmN","userReport":"XOX4Q","userCard":"_1L5aK","userName":"J4mrp","redText":"zPFqp","checkbox":"AIT9K"};